const PROVIDER = {
  IMAGE: 'image',
  YOUTUBE: 'youtube',
  CLIP: 'clip',
  MATTERPORT: 'matterport',
  SPINCAR: 'spincar',
};

const DEFAULT_TOUR_CONFIG = {
  alt: 'Tour virtual',
  title: 'tour-virtual',
  allow: 'accelerometer; autoplay; encrypted-media; gyroscope',
  frameBorder: 0,
  showSpinner: false,
};

const DEFAULT_YOUTUBE_CONFIG = {
  alt: 'youtube-video',
  title: 'tour-virtual',
  allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
  frameBorder: 0,
  showSpinner: false,
};

const CORE_PROVIDERS = [PROVIDER.IMAGE, PROVIDER.YOUTUBE];
const MULTIMEDIA_PROVIDERS = [PROVIDER.MATTERPORT, PROVIDER.SPINCAR, PROVIDER.YOUTUBE];
const VIRTUAL_TOUR_PROVIDERS = [PROVIDER.MATTERPORT, PROVIDER.SPINCAR];

export {
  PROVIDER,
  CORE_PROVIDERS,
  MULTIMEDIA_PROVIDERS,
  VIRTUAL_TOUR_PROVIDERS,
  DEFAULT_TOUR_CONFIG,
  DEFAULT_YOUTUBE_CONFIG,
};
